import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { Workspace } from "@/models/LazoWorkspace";
import { LazoWorkspaceCreation } from "@/models/LazoWorkSpaceCreation";
import { WorkspaceAndTenantMemberships } from "@/models/WorkspaceAndTenantMemberships";
import { WorkspaceChangeRequest } from "@/models/workspaces/WorkspaceChangeRequest";

class WorkspaceService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  getAllWorkspaces(): Promise<ApiResponseV2<Workspace[]>> {
    return HttpClientV2.get(`${this.path}/all`);
  }

  getWorkspacesAndTenantMembershipsForUser(): Promise<ApiResponseV2<WorkspaceAndTenantMemberships[]>> {
    return HttpClientV2.get(`${this.path}/tenant-memberships/all`);
  }

  async checkIfSlugIsTaken(slug: string): Promise<ApiResponseV2<boolean>> {
    return HttpClientV2.get(`${this.path}/is-taken?slug=${slug}`);
  }

  getOwnedWorkspaces(): Promise<ApiResponseV2<Workspace[]>> {
    return HttpClientV2.get(`${this.path}/owned`);
  }

  getWorkspacesByUserExternalId(externalId: string): Promise<ApiResponseV2<Workspace[]>> {
    return HttpClientV2.get(`${this.path}/by-user?externalId=${externalId}`);
  }

  changeRequest(dto: WorkspaceChangeRequest): Promise<ApiResponseV2<Workspace>> {
    return HttpClientV2.post(`${this.path}/change`, dto, {
      axiosConfig: {
        timeout: 30000,
      },
    });
  }

  createForCompany(workspace: LazoWorkspaceCreation): Promise<ApiResponseV2<Workspace>> {
    return HttpClientV2.post(`${this.path}/create-for-company`, workspace);
  }

  getByTenantExternalId(externalId: string): Promise<ApiResponseV2<Workspace>> {
    return HttpClientV2.get(`${this.path}/by-tenant?externalId=${externalId}`);
  }

  getInternalWorkspace(): Promise<ApiResponseV2<Workspace>> {
    return HttpClientV2.get(`${this.path}/internal`);
  }
}

export default new WorkspaceService("/api/workspace");
